import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Phone, Mail, MapPin, Clock, MessageCircle, Facebook, Instagram, Youtube, Linkedin, Twitter } from "lucide-react";

let infoPromise = null;
export const resetSiteInfo = () => { infoPromise = null; };
export function useSiteInfo() {
  const [info, setInfo] = useState({});
  useEffect(() => { (infoPromise ||= api.get("/public/site-info").then(({ data }) => data).catch(() => ({}))).then(setInfo); }, []);
  return info;
}
export const waLink = (n) => `https://wa.me/${String(n || "").replace(/\D/g, "").replace(/^(\d{10})$/, "91$1")}`;

const SOCIAL = [["facebook", Facebook], ["instagram", Instagram], ["youtube", Youtube], ["linkedin", Linkedin], ["x", Twitter]];

export function SiteFooter() {
  const s = useSiteInfo();
  const row = (Icon, text, href, id) => text && (
    <a href={href} className="flex items-start gap-2 text-sm text-slate-300 hover:text-white transition-colors" data-testid={`footer-${id}`} {...(href?.startsWith("http") ? { target: "_blank", rel: "noreferrer" } : {})}>
      <Icon className="h-4 w-4 mt-0.5 shrink-0 text-[#E3B04B]" /><span>{text}</span></a>);
  return (
    <footer className="bg-[#0A1424] text-slate-300 mt-16" data-testid="site-footer">
      <div className="max-w-6xl mx-auto px-5 py-12 grid gap-8 md:grid-cols-3">
        <div>
          <div className="inline-block bg-white rounded-lg px-2 py-1"><img src="/omi-logo.webp" alt="OMI Fintech Pvt Ltd" className="h-12 w-auto" /></div>
          <p className="text-sm mt-3 text-slate-400">Insurance and loan advisory. Final approval, premium and terms are decided by the insurer or lender.</p>
          <div className="flex gap-2 mt-4">{SOCIAL.map(([k, Icon]) => s[k] && (
            <a key={k} href={s[k]} target="_blank" rel="noreferrer" aria-label={k} data-testid={`footer-social-${k}`}
              className="h-9 w-9 rounded-full bg-white/10 hover:bg-[#E3B04B] hover:text-slate-900 flex items-center justify-center transition-colors"><Icon className="h-4 w-4" /></a>))}</div>
        </div>
        <div className="space-y-2.5">
          <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-1">Contact</div>
          {row(Phone, s.phone, `tel:${String(s.phone || "").replace(/[^\d+]/g, "")}`, "phone")}
          {row(MessageCircle, s.whatsapp && `WhatsApp ${s.whatsapp}`, waLink(s.whatsapp), "whatsapp")}
          {row(Mail, s.email, `mailto:${s.email}`, "email")}
          {row(MapPin, s.address, undefined, "address")}
          {row(Clock, s.hours, undefined, "hours")}
        </div>
        <div className="space-y-2 text-sm">
          <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-1">Quick links</div>
          <Link to="/" className="block hover:text-white">Home</Link>
          <Link to="/apply-loan" className="block hover:text-white">Apply for a loan</Link>
          <Link to="/status" className="block hover:text-white">Check request status</Link>
          <Link to="/login" className="block hover:text-white">Staff login</Link>
        </div>
      </div>
      <div className="border-t border-white/10 text-xs text-slate-500 text-center py-4">© {new Date().getFullYear()} OMI Fintech Pvt Ltd</div>
    </footer>
  );
}
